/* Файл подключает каждая glide-секция (на главной - 6 раз), а выполнять его нужно один раз: иначе hero
   запускается столько же раз - 30 точек на 5 слайдов и 6 таймеров автосмены (найдено 16.10). */
(function () {
if (window.glideHomeLoaded) return;
window.glideHomeLoaded = true;

/* GlideHome hero.
   Десктоп: кроссфейд слайдов (opacity) + автопрокрутка.
   Мобильный (<=768px): нативный CSS scroll-snap — свайп работает без JS.
   JS только доводит автопрокрутку и точки-индикатор. */
(function () {
  'use strict';

  function initHero(root) {
    var track = root.querySelector('[data-glide-track]');
    var dotsBox = root.querySelector('[data-glide-dots]');
    if (!track || !dotsBox) return;
    var slides = [].slice.call(track.querySelectorAll('[data-glide-slide]'));
    if (slides.length < 2) return;

    var SLIDE_MS = parseInt(root.getAttribute('data-autoplay-ms') || '6000', 10);
    var AUTOPLAY = root.getAttribute('data-autoplay') === 'true';
    var idx = 0, timer = null;
    var mq = window.matchMedia('(max-width: 768px)');
    var isMobile = function () { return mq.matches; };

    // точки
    slides.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Slide ' + (i + 1));
      b.addEventListener('click', function () { go(i, true); restart(); });
      dotsBox.appendChild(b);
    });
    var dots = [].slice.call(dotsBox.children);

    function paint() {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
    }

    function go(n, smooth) {
      idx = (n + slides.length) % slides.length;
      if (isMobile()) {
        track.scrollTo({ left: idx * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      }
      paint();
    }
    function next() { go(idx + 1, true); }
    function restart() {
      if (!AUTOPLAY || isMobile()) return;   // автосмена только на десктопе
      if (timer) clearInterval(timer);
      timer = setInterval(next, SLIDE_MS);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    // мобильный: следим за нативным скроллом, обновляем idx/точки
    var scrollRaf = null;
    track.addEventListener('scroll', function () {
      if (!isMobile()) return;
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () {
        scrollRaf = null;
        var w = track.clientWidth || 1;
        var n = Math.round(track.scrollLeft / w);
        if (n !== idx && n >= 0 && n < slides.length) { idx = n; paint(); }
      });
    }, { passive: true });

    // пауза автопрокрутки, пока трогают/скроллят
    var pauseT = null;
    function bump() { stop(); if (pauseT) clearTimeout(pauseT); pauseT = setTimeout(restart, 2500); }
    track.addEventListener('pointerdown', bump);
    track.addEventListener('touchstart', bump, { passive: true });
    track.addEventListener('wheel', bump, { passive: true });

    var prev = root.querySelector('[data-glide-prev]');
    var nextBtn = root.querySelector('[data-glide-next]');
    if (prev) prev.addEventListener('click', function () { go(idx - 1, true); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(idx + 1, true); restart(); });

    if (AUTOPLAY) {
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', restart);
    }

    // при смене вида (десктоп<->мобайл) выставить позицию
    var onMode = function () { go(idx, false); if (isMobile()) stop(); else restart(); };
    if (mq.addEventListener) mq.addEventListener('change', onMode);
    addEventListener('resize', function () { if (isMobile()) track.scrollLeft = idx * track.clientWidth; });

    go(0, false);
    restart();
  }

  function boot() { document.querySelectorAll('[data-glide-hero]').forEach(initHero); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-glide-hero]').forEach(initHero);
  });
})();

/* GlideHome content sections: scroll-reveal + FAQ view-all toggle. */
(function () {
  'use strict';
  function reveal() {
    var els = document.querySelectorAll('.glide-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
    setTimeout(function () {
      document.querySelectorAll('.glide-reveal:not(.is-in)').forEach(function (e) { e.classList.add('is-in'); });
    }, 2500);
  }
  function faq() {
    document.querySelectorAll('[data-glide-faq-toggle]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var sec = btn.closest('[data-glide-faq]');
        var open = sec.classList.toggle('is-open');
        btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
        if (!open) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }
  function boot() { reveal(); faq(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

/* GlideHome buy bar: показать после hero, скрыть у футера. */
(function () {
  'use strict';
  function initBar(bar) {
    if (bar.dataset.bound) return;
    bar.dataset.bound = '1';
    var after = parseInt(bar.getAttribute('data-show-after') || '600', 10);
    var raf = null;
    /* на компьютере (от 990px) Horizon крутит не окно, а .page-wrapper - window.scrollY там
       всегда 0, и панель не появлялась (SPEC.md, раздел 6, №15) */
    function scroller() {
      var pw = document.querySelector('.page-wrapper');
      if (pw && window.matchMedia('(min-width: 990px)').matches) {
        var o = getComputedStyle(pw).overflowY;
        if (o === 'auto' || o === 'scroll') return pw;
      }
      return document.scrollingElement || document.documentElement;
    }
    function update() {
      raf = null;
      var sc = scroller();
      var y = sc.scrollTop;
      var nearBottom = (y + sc.clientHeight) > (sc.scrollHeight - 420);
      var show = y > after && !nearBottom;
      bar.classList.toggle('is-shown', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    /* capture: прокрутка .page-wrapper не всплывает до window */
    addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true, capture: true });
    addEventListener('resize', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    update();
  }
  function boot() { document.querySelectorAll('[data-glide-buybar]').forEach(initBar); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

/* GlideHome PDP: галерея-карусель (свайп + drag мышью + стрелки) + смена варианта. */
(function () {
  'use strict';
  function initPdp(root) {
    if (root.dataset.bound) return;
    root.dataset.bound = '1';

    /* ---------- галерея-карусель ---------- */
    var track = root.querySelector('[data-glide-pdp-track]');
    var slides = track ? [].slice.call(track.querySelectorAll('[data-glide-pdp-slide]')) : [];
    var thumbs = [].slice.call(root.querySelectorAll('[data-glide-pdp-thumb]'));
    var prevBtn = root.querySelector('[data-glide-pdp-prev]');
    var nextBtn = root.querySelector('[data-glide-pdp-next]');
    var cur = 0;

    function setActive(i) {
      if (isNaN(i)) i = 0;
      cur = Math.max(0, Math.min(i, slides.length - 1));
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === cur); });
      if (prevBtn) prevBtn.hidden = cur <= 0;
      if (nextBtn) nextBtn.hidden = cur >= slides.length - 1;
      /* видео на ушедшем слайде не должно продолжать играть */
      slides.forEach(function (s, k) {
        if (k === cur) return;
        var vd = s.querySelector('video');
        if (vd && !vd.paused) vd.pause();
      });
    }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function goTo(i, smooth) {
      if (!track) return;
      cur = Math.max(0, Math.min(i, slides.length - 1));
      var left = cur * track.clientWidth;
      var behavior = (smooth === false || reduce) ? 'auto' : 'smooth';
      /* старые Safari не понимают scrollTo(options) — тогда простое присваивание */
      try { track.scrollTo({ left: left, behavior: behavior }); }
      catch (e) { track.scrollLeft = left; }
      setActive(cur);
    }
    /* clientWidth может быть 0, пока секция скрыта (перезагрузка в редакторе темы):
       без «|| 1» получится деление на ноль и NaN вместо номера слайда */
    function nearest() { return track ? Math.round(track.scrollLeft / (track.clientWidth || 1)) : 0; }

    if (track && slides.length) {
      var raf;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { setActive(nearest()); });
      }, { passive: true });

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-index'), 10) || 0); });
      });
      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(cur - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(cur + 1); });

      /* перетаскивание мышью/пальцем */
      var down = false, startX = 0, startScroll = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        /* не перехватывать клики по контролам видео / 3D-модели */
        if (e.target.closest && e.target.closest('video, iframe, model-viewer')) return;
        down = true; moved = false; startX = e.clientX; startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 3) moved = true;
        track.scrollLeft = startScroll - dx;
      });
      function endDrag() {
        if (!down) return;
        down = false;
        track.classList.remove('is-dragging');
        goTo(nearest());
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);
      /* не переходить по ссылке после drag */
      track.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); }
      }, true);
      /* клавиатура */
      track.setAttribute('tabindex', '0');
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(cur - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(cur + 1); }
      });

      window.addEventListener('resize', function () { goTo(cur, false); });
      setActive(0);
    }

    /* ---------- варианты ---------- */
    var raw = root.querySelector('[data-glide-pdp-variants]');
    if (!raw) return;
    var variants;
    try { variants = JSON.parse(raw.textContent); } catch (e) { return; }
    var selects = [].slice.call(root.querySelectorAll('[data-glide-pdp-opt]'));
    var idField = root.querySelector('[data-glide-pdp-id]');
    var priceEl = root.querySelector('[data-glide-pdp-price]');
    var compareEl = root.querySelector('[data-glide-pdp-compare]');
    var atc = root.querySelector('[data-glide-pdp-atc]');
    /* формат валюты не зашиваем: снимаем его с цены, которую отрисовал Shopify,
       иначе при переключении магазина на EUR/GBP вариант покажет чужой символ */
    var seed = priceEl ? priceEl.textContent.trim() : '';
    var pre = (seed.match(/^[^\d]*/) || [''])[0];
    var post = (seed.match(/[^\d]*$/) || [''])[0];
    function money(cents) {
      if (cents == null) return '';
      return pre + (cents / 100).toFixed(2) + post;
    }
    function pick() {
      var chosen = selects.map(function (s) { return s.value; });
      var v = variants.find(function (vv) {
        return vv.options.length === chosen.length && vv.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!v) return;
      if (idField) idField.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) compareEl.textContent = v.compare ? money(v.compare) : '';
      if (v.media_pos && v.media_pos > 0) goTo(v.media_pos - 1);
      if (atc) {
        atc.disabled = !v.available;
        var sp = atc.querySelector('span');
        if (sp) sp.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', pick); });
  }
  function boot() { document.querySelectorAll('[data-glide-pdp]').forEach(initPdp); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

})();
